import { buildTelemetryConfig } from '@rtd/dashboard';
const rtdAppInsightsConfig = buildTelemetryConfig();

export const rtdExtensions = { ...rtdAppInsightsConfig };
